import useBlProviders from '@/composables/providers/useBlProvider'

import WeightStationsDt from '@/services/dataTransferModules/weightStationDt'

export default function useWeightStations(params) {
	const weightStationsDt = new WeightStationsDt()

	const {
		loadEntityFlags: flags,

		entities: weightStations,
		getEntities: getWeightStations,

		extendedEntities: extendedWeightStations,
		getExtendedEntities: getExtendedWeightStations,
		getHashedExtendedEntities: getHashedExtendedWeightStations,

		entity: weightStation,
		getEntity: getWeightStation,

		entityPreview: weightStationPreview,
		getEntityPreview: getWeightStationPreview,
	} = useBlProviders(
		weightStationsDt,
		Object.assign(
			{
				showErrorNotificationForLoadingAllEntities: true,
				showErrorNotificationForLoadingOneEntity: true,
			},
			params,
		),
	)

	return {
		flags,
		weightStations,
		weightStation,
		weightStationPreview,
		extendedWeightStations,
		getWeightStations,
		getExtendedWeightStations,
		getHashedExtendedWeightStations,
		getWeightStation,
		getWeightStationPreview,
	}
}
